import { render } from "./send-verification-link.vue?vue&type=template&id=48840344&scoped=true"
import script from "./send-verification-link.vue?vue&type=script&lang=js"
export * from "./send-verification-link.vue?vue&type=script&lang=js"

import "./send-verification-link.vue?vue&type=style&index=0&id=48840344&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48840344"]])

export default __exports__